import { Sorting } from '@spilca/dictionary_ts/v1/dictionary_common/dictionary_common_pb';
import {
  ListProductPackageRequest,
  ListProductPackageResponse
} from '@spilca/dictionary_ts/v1/dictionary_md/product_package_pb';
import { DictionaryMdService } from '@spilca/dictionary_ts/v1/dictionary_web/dictionaries_md_pb_service';

import { filterProductPackageConstructor } from '@monorepo/dictionary';
import { createPagination } from '@monorepo/helpers';
import { getGrpcPromise } from '@monorepo/grpc';

type TFilter = {
  pageSize: number;
} & Record<string, any>;

const getProductPackageList = (
  filter: TFilter
): Promise<ListProductPackageResponse.AsObject> => {
  const request = new ListProductPackageRequest();

  const productPackageFilter = filterProductPackageConstructor(filter);
  request.setFilter(productPackageFilter);

  const pager = createPagination(filter.currentPage, filter.pageSize);
  request.setPagination(pager);

  const sort = new Sorting();
  sort.setFieldName('id');
  sort.setOrder(1);
  request.setSortingList([sort]);

  return getGrpcPromise(DictionaryMdService.ListProductPackage)(request);
};

export default getProductPackageList;
